import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMatch } from '../game/MatchContext';
import { levelInfo } from '../game/model.mjs';
import { FleetAnalysis } from '../components/FleetAnalysis';
import { Button, Notice, PageHeading } from '../components/UI';

export default function Analysis() {
  const { game, refresh, busy, error } = useMatch();
  const [automatic, setAutomatic] = useState(false);
  useEffect(() => {
    if (!automatic || game.status !== 'active') return;
    const timer = window.setInterval(() => { if (!document.hidden) refresh(); }, 3000);
    return () => window.clearInterval(timer);
  }, [automatic, game.status, refresh]);
  return <div className="analysis-page"><PageHeading title="Fleet analysis" subtitle={`${game.level} · ${levelInfo(game.level).short}`}><Link to={game.status === 'completed' ? '/game-results' : '/battle-interface'}>Return to {game.status === 'completed' ? 'results' : 'game'}</Link></PageHeading>
    <div className="analysis-refresh"><Button onClick={refresh} disabled={busy}>{busy ? 'Refreshing…' : 'Refresh match'}</Button>{game.status === 'active' && <label className="checkbox-label"><input type="checkbox" checked={automatic} onChange={event => setAutomatic(event.target.checked)} />Refresh every 3 seconds</label>}</div>
    {error && <Notice error>{error}</Notice>}<FleetAnalysis game={game} />
  </div>;
}
